module.exports = __webpack_public_path__ + "img/express-flower-gel-double-small@2x.654e2872.png";